
import React from 'react';

interface PrayerActionButtonProps {
  onPray: () => void;
  baseButton: string;
  accentGlow: string;
}

export default function PrayerActionButton({
  onPray,
  baseButton,
  accentGlow
}: PrayerActionButtonProps) {
  return (
    <button
      type="button" // ✅ Add this
      onClick={(e) => {
        e.stopPropagation();
        onPray();
      }}
      className={`${baseButton} ${accentGlow} group`}
      title="Pray for this"
      style={{ touchAction: 'manipulation' }}
    >
      <span className="text-lg">🙏</span>
    </button>
  );
}
